import type { Component } from "svelte";
import IconBus from '~icons/mdi/bus';
import IconClipboardList from '~icons/mdi/clipboard-list';
import IconCreditCard from '~icons/mdi/credit-card';
import IconFoodVariant from '~icons/mdi/food-variant';
import IconHandshake from '~icons/mdi/handshake';
import IconLanguage from '~icons/mdi/language';
import IconShieldCheck from '~icons/mdi/shield-check';
import IconShopping from '~icons/mdi/shopping';

export enum InsiderTipCategory {
    TRANSPORT = 'TRANSPORT',
    PAYMENT = 'PAYMENT',
    FOOD = 'FOOD',
    ETIQUETTE = 'ETIQUETTE',
    SAFETY = 'SAFETY',
    SHOPPING = 'SHOPPING',
    LANGUAGE = 'LANGUAGE',
    LOGISTICS = 'LOGISTICS',
}

export const INSIDER_TIP_ICONS: Record<InsiderTipCategory, Component> = {
    [InsiderTipCategory.TRANSPORT]: IconBus,
    [InsiderTipCategory.PAYMENT]: IconCreditCard,
    [InsiderTipCategory.FOOD]: IconFoodVariant,
    [InsiderTipCategory.ETIQUETTE]: IconHandshake,
    [InsiderTipCategory.SAFETY]: IconShieldCheck,
    [InsiderTipCategory.SHOPPING]: IconShopping,
    [InsiderTipCategory.LANGUAGE]: IconLanguage,
    [InsiderTipCategory.LOGISTICS]: IconClipboardList
}